import React from "react";

const SistemiOretPunes = () => {
  return <div>SistemiOretPunes</div>;
};

export default SistemiOretPunes;
